import {INavigateItem} from "@view/navigate/types";
import {NAVIGATE_LIST} from "@view/navigate/constants/navigate";
import {useMemo} from "react";
import {useAppContext} from "@context/appContext/hooks/useAppContext";
import {useGetUserAccess} from "@containers/account/access/hooks/useGetUserAccess";

export function useBuildNavigate(): INavigateItem[] {

    const {user, account} = useAppContext()
    const {getUserAccess} = useGetUserAccess()

    return useMemo(() => {
        return NAVIGATE_LIST.filter((nav) => {
            if (!nav?.accessProps) {
                return nav
            }

            if (typeof nav.accessProps === 'function') {
                return nav.accessProps({
                    user,
                    account,
                    getUserAccess,
                })
            }

            return getUserAccess(nav.accessProps)
        })
    }, [user, account, getUserAccess])
}
